import type {Pagination} from '../../../Data/types/BaseResponse';
import {MarketerTrackingRepositoryImpl} from '../repository/MarketerTrackingRepositoryImpl';
import type {SessionFilters, WorkSession} from '../models/session.model';

export interface GetMarketerSessionsResult {
  sessions: WorkSession[];
  pagination: Pagination;
}

export class GetMarketerSessionsUseCase {
  private readonly repository = new MarketerTrackingRepositoryImpl();

  async execute (
    marketerId: number | string,
    filters: Omit<SessionFilters, 'marketerId'> = {}
  ): Promise<GetMarketerSessionsResult> {
    return this.repository.getMarketerSessions(marketerId, filters);
  }
}
